import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import Window from '@nocode-works/template/components/dialog/Window'
import ValueGrid from 'components/widgets/ValueGrid'

import stripeSelectors from 'store/selectors/stripe'
import stripeActions from 'store/modules/stripe'
import priceUtils from 'utils/price'
import subscriptionUtils from 'utils/subscription'

const useStyles = makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}))

const ConfirmSubscriptionChangeWindow = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const subscription = useSelector(stripeSelectors.subscription)
  const changePlanInfoSummary = useSelector(stripeSelectors.changePlanInfoSummary)

  const onCancel = useCallback(() => {
    dispatch(stripeActions.setChangePlanWebsite(null))
    dispatch(stripeActions.setChangePlanInfo(null))
  })

  const onConfirm = useCallback(() => {
    dispatch(stripeActions.confirmSubscriptionChange())
  })

  const subscriptionInfo = subscriptionUtils.getSubscriptionInfo(subscription)

  return (
    <Window
      open
      withCancel
      title="Update Subscription"
      cancelTitle="Close"
      submitTitle="Confirm Change"
      size="md"
      onSubmit={ onConfirm }
      onCancel={ onCancel }
    >
      <Typography gutterBottom>
        You are changing the <strong>{ changePlanInfoSummary.website.name }</strong> website to the <strong>{ changePlanInfoSummary.product.name }</strong> plan.
      </Typography>
      <Typography gutterBottom>
        Your next invoice will include the cost of this change for the remaining part of your billing cycle.
      </Typography>
      <div className={ classes.divider }></div>
      <ValueGrid
        raw
        spacing={ 1 }
        titleSize={ 6 }
        data={
          [{
            title: <Divider />,
            value: <Divider />,
          }]
          .concat(
            subscriptionUtils.getLineItemsTable(changePlanInfoSummary.lineItems)
          )
          .concat([{
            title: <Divider />,
            value: <Divider />,
          },{
            title: 'Next invoice due:',
            value: (
              <strong>
                { subscriptionInfo.periodEnd }
              </strong>
            ),
          },{
            title: 'Your current monthly invoice:',
            value: (
              <span>
                <strong>{ subscriptionInfo.currency.symbol }{ priceUtils.displayPrice(subscriptionInfo.total) }</strong>
                &nbsp;per month
              </span>
            ),
          },{
            title: changePlanInfoSummary.cost >= 0 ?
              'Additional cost for remainder of billing cycle:' :
              'Refund for remainder of billing cycle:',
            value: (
              <span>
                <strong>{ subscriptionInfo.currency.symbol }{ priceUtils.displayPrice(changePlanInfoSummary.cost) }</strong>
                &nbsp;{ changePlanInfoSummary.cost >= 0 ? `(paid at the end of the billing cycle)` : '' }
              </span>
            ),
          },{
            title: `Your next invoice (${ subscriptionInfo.periodEnd }):`,
            value: (
              <span>
                <strong>{ subscriptionInfo.currency.symbol }{ priceUtils.displayPrice(changePlanInfoSummary.nextInvoice) }</strong>
                &nbsp;(includes additional cost for this billing cycle)
              </span>
            ),
          },{
            title: `Subsequent invoices (from ${ subscriptionInfo.nextPeriodStart }):`,
            value: (
              <span>
                <strong>{ subscriptionInfo.currency.symbol }{ priceUtils.displayPrice(changePlanInfoSummary.subsequentInvoices) }</strong>
                &nbsp;per month
              </span>
            ),
          }])
        }
      />
    </Window>
  )
}

export default ConfirmSubscriptionChangeWindow